<template>
    <v-card class="ma-3 pa-5 mt-12">
        <h4>Create new Station message</h4>
        <v-row class="mx-2 mt-3">
            <v-text-field v-model="newMessage.etText" class="mr-3" label="Text ET" type="text" />
            <v-text-field v-model="newMessage.enText" class="mr-3" label="Text EN" type="text" />
            <v-text-field v-model="newMessage.fiText" class="mr-3" label="Text FI" type="text" />
            <v-text-field v-model="newMessage.ltText" class="mr-3" label="Text LT" type="text" />

            <v-select
                :items="allProbes"
                item-text="name"
                item-value="probeId"
                v-model="newMessage.probes"
                label="Probes"
                hint="Pick stations"
                class="mr-3"
                multiple
                return-object
            >
                <template v-slot:selection="{ item, index }">
                    <span v-if="index === 0">{{ item.name }} </span>
                    <span v-if="index === 1" class="grey--text text-caption ml-1"
                        >(+ {{ newMessage.probes.length - 1 }} others)
                    </span>
                </template>
                <template v-slot:prepend-item>
                    <v-list-item ripple @mousedown.prevent @click="handleSelectAllClick(newMessage)">
                        <v-list-item-action>
                            <v-icon color="indigo darken-4">
                                {{ toggleAllIcon(newMessage) }}
                            </v-icon>
                        </v-list-item-action>
                        <v-list-item-content>
                            <v-list-item-title>
                                Select All
                            </v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                    <v-divider class="mt-2"></v-divider>
                </template>
            </v-select>

            <v-select
                :items="['suggestion', 'info', 'warning']"
                class="mr-3"
                label="Type"
                v-model="newMessage.messageType"
            />
            <v-btn class="mt-4 ml-4" color="primary" small @click="createMessage">Create</v-btn>
        </v-row>
    </v-card>
</template>
<script>
import { mapActions, mapState } from 'vuex'

export default {
    name: 'CreateStationMessageCard',
    computed: {
        ...mapState('stationMessage', ['newMessage', 'allProbes']),
    },
    methods: {
        ...mapActions('stationMessage', ['createNewStationMessage', 'getAllStationMessages']),
        async createMessage() {
            if (!this.newMessage.messageType) return alert('add message type')
            await this.createNewStationMessage()
            await this.getAllStationMessages()
        },
        handleSelectAllClick(item) {
            if (item.probes.length === this.allProbes.length) {
                item.probes = []
            } else {
                item.probes = this.allProbes
            }
        },
        toggleAllIcon(item) {
            if (item.probes.length === this.allProbes.length) return 'mdi-close-box'
            if (item.probes.length > 0) return 'mdi-minus-box'
            return 'mdi-checkbox-blank-outline'
        },
    },
}
</script>

<style scoped></style>
